import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Single switch handler for header selector, dashboard cards, and empty-state picks.
 * Writes selectedCustomerId only — never touches token / logout.
 * Cart keep/clear confirmation is PA-07; respect switchingLocked when set.
 */
export default function useSwitchChild() {
	const dispatch = useDispatch();
	const children = useSelector((state) => state.auth.children) || [];
	const selectedCustomerId = useSelector((state) => state.auth.selectedCustomerId);
	const switchingLocked = useSelector((state) => state.auth.switchingLocked);

	const switchChild = useCallback(
		(customerId) => {
			if (switchingLocked) {
				return { ok: false, reason: 'locked' };
			}

			if (customerId == null || customerId === '') {
				return { ok: false, reason: 'missing' };
			}

			const id = Number(customerId);
			const allowed = children.some((c) => Number(c.id) === id);
			if (!allowed) {
				return { ok: false, reason: 'unauthorized' };
			}

			if (Number(selectedCustomerId) === id) {
				return { ok: true, reason: 'unchanged' };
			}

			dispatch({ type: 'auth/setSelectedCustomerId', payload: id });
			return { ok: true, reason: 'switched' };
		},
		[children, dispatch, selectedCustomerId, switchingLocked]
	);

	return { switchChild, switchingLocked, selectedCustomerId, children };
}
